/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DownloadThumbnailResponse
 */
export interface DownloadThumbnailResponse {
    /**
     * 
     * @type {string}
     * @memberof DownloadThumbnailResponse
     */
    thumbnail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DownloadThumbnailResponse
     */
    noImage: boolean;
}

/**
 * Check if a given object implements the DownloadThumbnailResponse interface.
 */
export function instanceOfDownloadThumbnailResponse(value: object): value is DownloadThumbnailResponse {
    if (!('noImage' in value) || value['noImage'] === undefined) return false;
    return true;
}

export function DownloadThumbnailResponseFromJSON(json: any): DownloadThumbnailResponse {
    return DownloadThumbnailResponseFromJSONTyped(json, false);
}

export function DownloadThumbnailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadThumbnailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'thumbnail': json['thumbnail'] == null ? undefined : json['thumbnail'],
        'noImage': json['noImage'],
    };
}

  export function DownloadThumbnailResponseToJSON(json: any): DownloadThumbnailResponse {
      return DownloadThumbnailResponseToJSONTyped(json, false);
  }

  export function DownloadThumbnailResponseToJSONTyped(value?: DownloadThumbnailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thumbnail': value['thumbnail'],
        'noImage': value['noImage'],
    };
}

